module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle"
  }, [_c('span', {
    staticClass: "xrefInternal"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#fm_02"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Eve")])])])]), _vm._v(" "), _c('p', {
    staticClass: "chapterSubtitle"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("A.D. 5664")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Ghost cruiser hovered between Earth and Moon")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The ship was a rough ovoid, woven from silvered rope. Instrument clusters and energy pods were knotted to the walls. Around me, Ghosts clung to the rope like grapes to a vine.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The blue of crescent Earth shimmered over their pulsating, convex surfaces.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Earth folded up and disappeared.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The first hyperspace hop was immense, thousands of light years long. Then, in a succession of bewildering leaps, we sailed out of the Galaxy.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("We fell obliquely to the plane of the disc. The core was a chandelier of pink-white light, thousands of light years across, hanging over my head. Spiral arms—cloudy, streaming—moved serenely above me. There were blisters of gas sprinkled along the arms, I saw, bubbles of swollen colour.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Galactic light glimmered over the silvered flesh of the Ghosts, and of my own body")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("We reached the Ghosts’ base—far from home, in the halo of the Galaxy")]), _vm._v(".")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page12"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("It was a typical Ghost construct: a hollowed-out moon, a rock ball a thousand miles wide, and it was riddled with passages and cavities. It hung beneath the great ceiling of the Galaxy, the only large object visible as other than a smudge of light.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("We descended. The moon turned into a complex, machined landscape below me. Our ship shut down its drive and entered a high, looping orbit. The Ghosts drifted away from the ship and down towards the surface, bobbing like balloons, shining in Galaxy light.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I let go of the ship and floated away from its tangled hull.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ghost ships and science platforms swept over the pocked landscape, fragments of shining net. All over the surface, vast cylindrical structures gleamed. These were intrasystem drives and hyperdrives, systems which had been used to haul this moon—at huge expense—out of the plane of the Galaxy, and to hold it here.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("There was quagma down there, I saw, little packets of the primordial stuff, buried in the pits of ancient planetesimal craters. My information had been good, then.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("What in Lethe were the Ghosts doing out here?")])]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The world of the Silver Ghosts was once earthlike: blue skies, a yellow sun")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("As the Ghosts climbed to awareness their sun evaporated, killed by a companion pulsar. When the atmosphere started snowing, the Ghosts rebuilt themselves.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("That epochal ordeal left the Ghosts determined, secretive, often reckless. Dangerous.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("They moved out into space—the Heat Sink—to fulfill their ambitions.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I had been told the Ghosts were close to completing their new quagma project. I was chief administrator of the Ghost liaison office, representing most of mankind. It was my job to stop the Ghosts endangering us all.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("So that I could deal with the Ghosts, I was remade, a "), _c('a', {
    attrs: {
      "id": "page13"
    }
  }), _vm._v("decade ago.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I look like a statue of a man, done in silver, or chrome. My legs are pillars. My hands and arms have been made immensely strong. I don’t live behind my eyes anymore: I live in my chest cavity. I feel like a deep-sea fish, blind and almost immobile, stuck here in the dark. My mechanical eyes are like periscopes, far above “me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I can subsist on starlight, and survive the vacuum for days at a time, enfolding my seventy-six-year-old human core—me—in warmth and darkness. I have a Ghost doctor; twice a year it opens me up and cleans me out.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I have a face, a sculpture of eyes, nose, mouth. It doesn’t even look much like I used to, before. It doesn’t matter; apart from the eyes, the face is non-functional, put there to reassure me.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I can run with the Ghosts. I can fly in space, if I choose to. I don’t, much. When I’m not dealing with the Ghosts I spend most of my time in Virtual environments.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("So my physical form doesn’t matter much. In fact, lately I’ve come to wish the Ghosts had just rebuilt me as a sphere, as they are: simple, classical, efficient")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A Ghost came soaring up to me. It was a silvery, five-feet-wide globe, complex patterns shimmering over its surface. I recognized it from its electromagnetic signature: contrary to myth, Ghosts aren’t all alike, at least not to another Ghost")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I greeted it. “Sink Ambassador.”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Ambassador to the Heat Sink floated before me, shimmering; I could see my own distorted reflection in its hide. “Jack Raoul. It has been many years—”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“More than a decade.”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“It is pleasant to meet with you. Even if your journey has been a wasted one.”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("So it began: the endless diplomatic dance. I’ve known the Ambassador, on and off, for a long time, and we have a cer"), _c('a', {
    attrs: {
      "id": "page14"
    }
  }), _vm._v("tain—friendship, I guess you’d call it. But none of that is ever allowed to interfere with species imperatives.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“I presume you want to get straight down to business, Sink Ambassador? It’s clear—I can see—that you’re running fresh quagma experiments down there, on that moon. What are you up to now?”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“We have no need to justify our actions. You have no authority over our activities.”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Oh, yes, we do. By force of treaty we have the right of inspection of any quagma-related project you run. You know that very well. Just as you have reciprocal rights over us.”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("It was true.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The study of primordial quagma—relics of the Big Bang—has proven immensely dangerous. Even to the extent of drawing the attention of the Xeelee.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Humanity—and the Silver Ghosts, and a host of other spacefaring species—have grown accustomed to the aloof gaze of the Xeelee, and their occasional devastating intervention in our affairs. For example, fifty years ago the Xeelee disrupted the Ghost and human expeditions which crossed the Universe in search of a fragment of quagma.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Some believe that by such interventions the Xeelee are maintaining their monopoly on power, which holds sway across the observable Universe. Others say that, like the vengeful gods of man’s childhood, the Xeelee are protecting us from ourselves.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Either way, it’s insulting. Claustrophobic.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("In my time with them I’ve developed a hunch that the Ghosts feel pretty much the same. Which makes them even more dangerous.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Four decades after those first expeditions, we’d turned up evidence that the Ghosts were performing experiments with quagma, in violation of treaties between our races. I was sent to see.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The lead turned out to be accurate. The Ghosts’ dangerous project was unfolding in the heart of a red giant star—"), _c('a', {
    attrs: {
      "id": "page15"
    }
  }), _vm._v("concealing their work from the Xeelee, and, incidentally, from us.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The disastrous outcome of that project all but destroyed us.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("After that, human surveillance of Ghost quagma projects was stepped up.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("And now it seemed that the Ghosts were at it again.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Sink Ambassador said, “You do not understand, Jack Raoul.”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Oh, don’t I?”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“This is a new program, of great significance. We have every right to progress it, unhindered. Now.” It suddenly turned hospitable. “You have traveled a long way. Your doctor is on hand. Perhaps you wish to rest, before returning to the plane of the Galaxy—”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I approached it, holding my arms out wide, my silvered hands raised like weapons. I hoped that the Ghosts—the Sink Ambassador at any rate—had studied humans sufficiently to get something out of my body language. “Sink Ambassador, we’re not going to let this go. We have to know what you’re doing, out here.” I pushed my sculptured face so close to its silvery hide I could see my own distorted reflection. “After last time, we’re quite prepared to use force.”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("It seemed to stiffen; I tried to read the thin tones of the translator chips. “Is this some formal declaration of—”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Not at all,” I said. “Our communications are secure, right now. This is just you, and me, out here in the halo of the Galaxy. I simply want you to understand the whole picture, Sink Ambassador.”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("It hovered in space for a long time, complex standing waves shimmering across its surface. Then: “Very well. Jack Raoul—what do you know of dark matter?”")])]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Dark matter: a shadow Universe which permeates, barely touching, the visible worlds we inhabit…And yet that image was misleading, for the dark matter is no shadow; it com"), _c('a', {
    attrs: {
      "id": "page16"
    }
  }), _vm._v("prises fully nine-tenths of the Universe’s total mass. The glowing, baryonic matter which makes up stars, planets, humans, is a mere glittering froth on the surface of that dark ocean")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I let the Ambassador download data into me. In my enhanced vision, huge Virtual schematics overlaid the Galaxy’s majestic disc.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Dark matter cannot form stars,” the Sink Ambassador said. “As a result, much larger clouds—larger than galaxies—are the equilibrium form for dark matter. The Universe is populated by immense, cold, bland clouds of dark matter: it is a spectral cosmos, almost without structure.”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“This is no doubt fascinating, Sink Ambassador, but I don’t see—”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Jack Raoul, we believe we have found a way to construct soliton stars: stellar-mass objects, of dark matter. Such is the purpose of the experiment, conducted here. We will build the first dark matter stars, the first in the Universe’s history.”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I pondered that. It was a typically grandiose Ghost scheme.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("But—what was its true goal?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("And why all the secrecy, from the Xeelee and from us? I knew there must be layers of truth, hidden beneath the surface of what the Ambassador had told me, just as their nuggets of quagma had been inexpertly hidden beneath the regolith of their hollowed-out moon.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“…Maybe I can answer your questions, Jack.”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("From the glands stored within my silver hide, adrenaline pumped into my system. I turned.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Eve.”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("My dead wife smiled at me.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Sink Ambassador receded, turning to a tiny point of light. The Galaxy shimmered like a Ghost’s hide, dimming.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Then all the stars went out")]), _vm._v(".")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page17"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I looked down at myself. I was human again")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Once we’d owned an apartment at the heart of the New Bronx. It was a nice place, light and roomy, with state-of-the-art Virtual walls. Since my metamorphosis, I can’t use it anymore, but I keep it anyhow, leaving it unoccupied. Unchanged, in fact, since Eve’s death. I just like to know it’s there.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Now I was back in that apartment. I was alone.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I went to the drinks cabinet, poured myself a malt, and waited. I can still drink, of course, but I’ve discovered that much of the pleasure of liquor comes from the tactile sensations of the bottle clinking against the glass, the heavy mass of the liquor in the base of the glass, the first rush of flavor.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Being injected just isn’t the same.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I savoured my malt. It was terrific. There was more processing power behind this simulation, whatever it was, than any I’d encountered before—")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("One wall melted. Eve was sitting on a couch like mine. She smiled at me again.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“You have a lot of questions,” she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I sipped my drink. “Will you join me?”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("She shook her head. She looked older than when she’d died. She pulled at a lock of hair, a habit she’d had since she was a child.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I said, “This is a Virtual simulation, right?”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“In a sense.”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“You’re not Eve. If you were, you wouldn’t even be here.” Even the Virtual copy of Eve would have cared too much to do this to me, to plunge me back into this self-regarding mess.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Despite my loneliness after the metamorphosis, I hadn’t called up Eve in seven, eight years.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Jack, I’m a better image than any you’ve seen before. Richer. Indistinguishable from—”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“No. I can distinguish.”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("She said, “You must understand what the Ghosts are do"), _c('a', {
    attrs: {
      "id": "page18"
    }
  }), _vm._v("ing here. And why you must allow them to proceed.”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Oh, must I? And you’re here to persuade me, right?”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("She stepped up to the surface of the Virtual wall which separated us. After a moment, I put down my drink and approached her.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("She stepped out of the wall.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I could feel her warmth, the feather of her breath on my face. My heart was pounding, somewhere, in a hollow metal chest cavity.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("…But even as I stared at Eve, I was figuring how much processing power this Virtual must be demanding. This creature with me wasn’t Eve, and it sure wasn’t the cosy untouchable Virtual representation my apartment used to call up. How were the Ghosts doing this?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("She held out her hand. I reached out, and my fingers passed through her arm; her flesh, crumbling into cuboid pixels, had the texture of dead leaves.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“I’m sorry.” She pushed back her hair. She reached out to me again.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("This time, when her fingers settled in mine, they were warm and soft; her hand was like a bird, living and responsive.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Oh, Eve.” I couldn’t help myself.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Jack, you must understand.”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Behind her, the wall turned black.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Eve’s hand was still warm in mine. “You must watch,” she told me, “and learn. It is a long story…”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("There was a patch of light, diffuse, in the center of the wall. It resolved into the blue Earth. Ships swam around it, on sparks of light")]), _vm._v(".")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b24d6672","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pro.vue
// module id = 72
// module chunks = 0